type TestimonialIndex = 1 | 2 | 3 | 4 | 5 | 6;

interface Testimonial {
  quoteKey: `testimonial${TestimonialIndex}Quote`;
  nameKey: `testimonial${TestimonialIndex}Name`;
  roleKey: `testimonial${TestimonialIndex}Role`;
}

export const TESTIMONIALS: readonly Testimonial[] = [
  {
    quoteKey: "testimonial1Quote",
    nameKey: "testimonial1Name",
    roleKey: "testimonial1Role",
  },
  {
    quoteKey: "testimonial2Quote",
    nameKey: "testimonial2Name",
    roleKey: "testimonial2Role",
  },
  {
    quoteKey: "testimonial3Quote",
    nameKey: "testimonial3Name",
    roleKey: "testimonial3Role",
  },
  {
    quoteKey: "testimonial4Quote",
    nameKey: "testimonial4Name",
    roleKey: "testimonial4Role",
  },
  {
    quoteKey: "testimonial5Quote",
    nameKey: "testimonial5Name",
    roleKey: "testimonial5Role",
  },
  {
    quoteKey: "testimonial6Quote",
    nameKey: "testimonial6Name",
    roleKey: "testimonial6Role",
  },
] as const;
